import MDButton from "components/MDButton";
import React, { useEffect, useState } from "react";
import MDModal from "components/MDModal";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { Edit } from "@mui/icons-material";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  TextareaAutosize,
} from "@mui/material";
import { useAppServices, useUploadImage } from "hook/services";
import { useUserInfo } from "context/user";
import FormField from "components/FormField";
import MDInput from "components/MDInput";
import Multiselect from "./components/Multiselect";
import { useAgencyInfo } from "context/agency";

const CreateModal = ({ products, handleRefresh }) => {
  const [agency] = useAgencyInfo();

  const uploadImage = useUploadImage();
  const [openAddProduct, setOpenAddProduct] = useState(false);
  const AppService = useAppServices();
  const [user] = useUserInfo();
  var axios = require("axios");

  const permissions = [
    {
      label: "Store",
      value: "Stores",
    },
    {
      label: "View Store",
      value: "store",
    },
    {
      label: "Teams",
      value: "teams",
    },
    {
      label: "Theme",
      value: "theme",
    },
    {
      label: "Navigation",
      value: "categories",
    },
    {
      label: "Tasks",
      value: "tasks",
    },
    {
      label: "Purchases",
      value: "Purchase",
    },
    {
      label: "All Purchases",
      value: "purchases",
    },
    {
      label: "Users Purchases",
      value: "users",
    },
    {
      label: "Locations Purchases",
      value: "locations",
    },
    {
      label: "Listings",
      value: "listings",
    },
    {
      label: "Snapshots Listings",
      value: "snapshots",
    },
    {
      label: "Services Listings",
      value: "services",
    },
    {
      label: "Bundles Listings",
      value: "bundles",
    },
    {
      label: "GHL Apps",
      value: "ghlapp",
    },
    {
      label: "All Apps",
      value: "ghlapps",
    },
    {
      label: "Widget Apps",
      value: "widget",
    },
    {
      label: "Workflow Apps",
      value: "apps",
    },
  ];
  const handlemodal = () => {
    setOpenAddProduct(true);
  };
 
  function AddProduct({ open, onClose }) {
    const [processing, setProcessing] = useState(false);

    const handleSubmit = async (e) => {
      e.preventDefault();
      // setProcessing(true);
      const payload = {
        name: e.target.name.value,
        count: e.target.count.value,
      };

      const { response } = await AppService.apikey_queries.create({
        payload: payload,
      });
       ;
      if (response) {
        setProcessing(false);
        onClose();
        handleRefresh();
      }
    };
    return (
      <MDModal open={open} onClose={onClose} width={440}>
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form">
            <MDTypography variant="h5" mb={2}>
              Create Api Keys
            </MDTypography>

            <MDBox>
              <MDTypography
                variant="button"
                sx={{ fontSize: "14px", fontWeight: "500" }}
                mb={1}
              >
                Name
              </MDTypography>
              <MDInput label="Name" placeholder="Name" name="name" fullWidth />
            </MDBox>
            <MDBox>
              <MDTypography
                variant="button"
                sx={{ fontSize: "14px", fontWeight: "500" }}
                mb={1}
              >
                Count
              </MDTypography>
              <MDInput
                label="Count"
                placeholder="Count"
                name="count"
                fullWidth
              />
            </MDBox>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 4, mb: 1 }}
                onClick={closeAddProduct}
              >
                close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 4, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Add
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    );
  }
  const closeAddProduct = () => {
    // if (subscription?._id)
    setOpenAddProduct(false);
  };
  return (
    <>
      <MDButton color="white" variant="contained" onClick={handlemodal}>
        Create
      </MDButton>
      <AddProduct open={openAddProduct} onClose={closeAddProduct} />
    </>
  );
};

export default CreateModal;
